import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { UserDetailContent } from './UserDetailContent';

export default function UserDetailPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <UserDetailContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
